import { ReactElement } from 'react';
import classNames from 'classnames';
import { Icon } from '@nx-frontend/shared/ui/icon';
import { getBorderClassNames, getTextClassNames } from '@nx-frontend/shared/themes';
import { PortalBorderType, PortalStyleConfig, PortalTextType, ThemeColorSchemas } from '@nx-frontend/shared/types';

interface ListItemProps {
  icon: ReactElement;
  themeColors: ThemeColorSchemas;
  themeStyle: PortalStyleConfig;
}

export const ListItemIcon: React.FC<ListItemProps> = ({ icon, themeColors, themeStyle }) => {
  return (
    <div
      className={classNames(
        'rounded p-1.5',
        ...getTextClassNames(themeColors, PortalTextType.SURFACE_3),
        ...getBorderClassNames(themeColors, themeStyle, PortalBorderType.SURFACE)
      )}
    >
      <Icon icon={icon} className="h-4 w-4" />
    </div>
  );
};
